import { getLink } from "../../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Mi ne plu dancos sur streĉita ŝnur’, <br/>
        Sur balancil’ ne plu balanciĝos mi, <br/>
        La balancil’, pendanta de ĉielo – <br/>
        Aĥ, ĉio okazas, kiel devas.
      </p>
      
      <p class="poem-block mb-3">
        Ne estus mi fiera en la viv’, <br/>
        Ne pensus, ke nekomparebla mi, sen par’, <br/>
        Tiam aliel estus ĉio nun, - <br/>
        Sed mi meritas, kion havas.
      </p>
      
      <p class="poem-block mb-3">
        Mi ne forvelkis pro la senesper’, <br/>
        Verŝajne, rompus trostreĉita ŝnur’, <br/>
        Kaj mi ne povus ĝin kunligi, <br/>
        Por ke ĉio okazu, kiel devas.
      </p>
      
      <p class="poem-block mb-3">
        Kvankam hazarde restis viva mi -  <br/>
        Sed kion travivis mi, estis falo ja. <br/>
        Sed mi ne serĉas la kulpulojn – <br/>
        Nu, ĉio okazas, kiel devas.
      </p>
      
      <p class="poem-block mb-3">
        La balancilo balanciĝas dum <br/>
        La ŝnuro varmas tie, kie mi tenis ĝin. <br/>
        Trairis mi inferon tutan. <br/>
        Ĉu ĉio okazis, kiel devas?
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: '* * *'
}

const item = {
  itemlink: getLink(itemName.esp, 'matveeva'),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;